// static/js/graphQL/hubHttpLink.ts
import { createHubHttpLink } from 'apollo-link-hub-http';
import { createStack } from 'hub-http';
import hubapiStack from 'hub-http/stacks/hubapi';
import { defaultTo } from 'hub-http/middlewares/core';

// set default timeout of 10s for all requests
export const hubHttpLink = createHubHttpLink(createStack(defaultTo('timeout', 10e3), hubapiStack));